// Styles for LegalSeparator go here.
import styled from 'styled-components';

export const StyledLegalSeparator = styled.div``;
